export default () => ({
  isTwoFaEnabled: false,
  qrCodeDataUrl: "",
  secretKey: "",
  isLoading: false,
  message: "",
});
